type RecordValue = Record<string, unknown>;

const record = (value: unknown): RecordValue | undefined =>
  value !== null && typeof value === "object" && !Array.isArray(value)
    ? (value as RecordValue)
    : undefined;

export type NarrationLocaleSummary = {
  requested: string;
  effective: string;
  source: string;
  fallback: string | null;
  acousticStatus: string;
};

/** A qualified route is distinct from a listening assessment of this take. */
export function summarizeNarrationLocale(
  envelope: RecordValue | undefined,
): NarrationLocaleSummary | null {
  const resolved = record(envelope?.resolved_voice);
  const diagnostics = record(envelope?.diagnostics);
  const voiceover = record(diagnostics?.voiceover);
  const locale = record(
    voiceover?.narration_locale ?? resolved?.narration_locale,
  );
  if (locale?.schema_version !== "narration-locale-decision.v1") return null;
  const validLocale = (value: unknown): value is string =>
    typeof value === "string" && /^es-(?:[A-Z]{2}|419)$/.test(value);
  if (
    !validLocale(locale.requested_voice_locale) ||
    !validLocale(locale.effective_voice_locale)
  ) {
    return null;
  }
  return {
    requested: locale.requested_voice_locale,
    effective: locale.effective_voice_locale,
    source: typeof locale.source === "string" ? locale.source : "unknown",
    fallback:
      typeof locale.fallback_reason === "string"
        ? locale.fallback_reason
        : null,
    acousticStatus: "This output has not been assessed by a listener",
  };
}
